import { LanguageService } from '@/services';
import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-create-quiz-information-dialog',
    templateUrl: './create-quiz-information-dialog.component.html',
    styleUrls: ['./create-quiz-information-dialog.component.scss'],
    standalone: false
})
export class CreateQuizInformationDialogComponent implements OnInit {
  reportingURL: string;

  constructor(
    private notificationService: NotificationService,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {
    this.reportingURL = environment.api + '/quiz-results/store';
  }

  copy() {
    this.notificationService.success(
      this.languageService.translateWithCap('general.notifications.copied-to-clipboard')
    );
  }
}
